// Professional business portraits for the AI buyer persona. 10 male + 10 female.
// The photo is chosen by the gender inferred from the persona's name, and is
// deterministic (same name → same face).
const PHOTO: Record<'male' | 'female', string[]> = {
  male: [
    '1472099645785-5658abf4ff4e', '1560250097-0b93528c311a', '1507003211169-0a1dd7228f2d',
    '1568602471122-7832951cc4c5', '1463453091185-61582044d556', '1557862921-37829c790f19',
    '1500648767791-00dcc994a43e', '1506794778202-cad84cf45f1d', '1599566150163-29194dcaad36',
    '1519345182560-3f2917c472ef',
  ],
  female: [
    '1573496359142-b8d87734a5a2', '1580489944761-15a19d654956', '1551836022-d5d88e9218df',
    '1556157382-97eda2d62296', '1592621385612-4d7129426394', '1594744803329-e58b31de8bf5',
    '1565884280295-98eb83e41c65', '1598550874175-4d0ef436c909', '1607746882042-944635dfe10e',
    '1551024601-bec78aea704b',
  ],
};

const unsplash = (id: string, size = 480) =>
  `https://images.unsplash.com/photo-${id}?w=${size}&h=${size}&fit=crop&crop=faces&auto=format&q=80`;

// Curated first names (cover the app's personas) + ES/IT heuristic: names ending
// in "a" are usually female.
const MALE = new Set(['alejandro', 'javier', 'alessandro', 'stefano', 'igor', 'marco', 'luca', 'sergio', 'pablo', 'diego', 'andrea']);
const FEMALE = new Set(['carmen', 'sofia', 'laura', 'giulia', 'lucia', 'elena', 'marta', 'paula', 'sara', 'chiara', 'francesca']);

export function genderFromName(fullName: string | null | undefined): 'male' | 'female' {
  const first = (fullName ?? '').trim().split(/\s+/)[0]?.toLowerCase() ?? '';
  if (MALE.has(first)) return 'male';
  if (FEMALE.has(first)) return 'female';
  return first.endsWith('a') ? 'female' : 'male';
}

function hash(s: string): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h;
}

/** Deterministic professional photo URL for an AI persona, by inferred gender. */
export function personaPhotoUrl(name: string | null | undefined, size = 480): string {
  const key = name && name.trim() ? name.trim() : 'persona';
  const pool = PHOTO[genderFromName(key)];
  return unsplash(pool[hash(key) % pool.length], size);
}
